export default __webpack_public_path__ + "5e7ccf4d0a89e0b20e7bec0773fa9ab6.svg";